import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute from 'lumen/routes/hotel/settings/competitors/benchmark/compset/builder';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkCompsetBuilderProposalsRoute extends Route {
  @service declare router: Services['router'];

  afterModel(
    model: ModelFrom<HotelSettingsCompetitorsBenchmarkCompsetBuilderProposalsRoute>,
  ): void {
    if (!model.proposedCompsets.last?.value) {
      // Normally, the proposals should have been fetched earlier in the flow. If that's not the case, go back to the step where we fetch the proposed compsets.
      this.router.transitionTo(
        'hotel.settings.competitors.benchmark.compset.builder.generate',
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const parentModel = this.modelFor(
      'hotel.settings.competitors.benchmark.compset.builder',
    ) as ModelFrom<HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute>;

    return parentModel;
  }
}
